import { render, staticRenderFns } from "./SelectedOptions.vue?vue&type=template&id=5e5138bd&scoped=true&"
import script from "./SelectedOptions.vue?vue&type=script&lang=js&"
export * from "./SelectedOptions.vue?vue&type=script&lang=js&"
import style0 from "./SelectedOptions.vue?vue&type=style&index=0&id=5e5138bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5138bd",
  null
  
)

export default component.exports